// TODO(tsgo): Remove when microsoft/typescript-go#1034 is fixed (check after tsgo 7.1+)
import { addFilesToCatalogAgentThread } from "./schema/catalog-agent/add-files-to-catalog-agent-thread";
import { confirmCatalogAgentTool } from "./schema/catalog-agent/confirm-catalog-agent-tool";
import { getCatalogAgentThread } from "./schema/catalog-agent/get-catalog-agent-thread";
import { streamCatalogAgent } from "./schema/catalog-agent/stream-catalog-agent";
import { uploadCatalogAgentFile } from "./schema/catalog-agent/upload-catalog-agent-file";

export const groupJ: {
  addFilesToCatalogAgentThread: typeof addFilesToCatalogAgentThread;
  streamCatalogAgent: typeof streamCatalogAgent;
  uploadCatalogAgentFile: typeof uploadCatalogAgentFile;
  confirmCatalogAgentTool: typeof confirmCatalogAgentTool;
  getCatalogAgentThread: typeof getCatalogAgentThread;
} = {
  addFilesToCatalogAgentThread,
  streamCatalogAgent,
  uploadCatalogAgentFile,
  confirmCatalogAgentTool,
  getCatalogAgentThread,
};
